const { HOST_URL } = process.env;

export const MODULES_URL = `${HOST_URL}/static/modules.json`;
